
export default [
    {
      id: 1,
      name: "Name1",
      email: "1@name.pl",
      age: 20
    },
    {
      id: 1,
      name: "Name2",
      email: "2@name.pl",
      age: 20
    }
  ];
  